import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadingIcon from "@mui/icons-material/Downloading";
import { downloadEvidence } from "services/api";
import { useTranslation } from "react-i18next";
import { Download } from "@mui/icons-material";

const EvidenceDownloadButton = ({ fileName, performanceId, isSelfEvidence, myScorecardView }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!fileName) return;

    setLoading(true);
    try {
      const response = await downloadEvidence(performanceId, fileName, isSelfEvidence);

    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Tooltip
      // if it's myScorecard view: use self evidence label, else (it will be assess view) so check if it is self evidence
      // if it's self evidence: use employee evidence label, else use assessor label
      title={
        fileName
          ? t(
              myScorecardView 
                ? "user.myScorecard.evidence.SelfEvidenceLabel"
                : isSelfEvidence
                  ? "user.myScorecard.evidence.EmployeeEvidenceLabel"
                  : "user.myScorecard.evidence.AssessorEvidenceLabel",
              { fileName }
            )
          : ""
      }
      arrow
    >
      <IconButton
        size="small"
        sx={{
          color: fileName ? "green" : "gray",
        }}
        disabled={!fileName || loading}
        onClick={handleDownload}
      >
        {!loading ? <Download /> : <DownloadingIcon />}
      </IconButton>
    </Tooltip>
  );
};

// ✅ PropTypes definition
EvidenceDownloadButton.propTypes = {
  fileName: PropTypes.string,
  performanceId: PropTypes.number.isRequired,
  downloadEvidence: PropTypes.func.isRequired,
  isSelfEvidence: PropTypes.bool,
  myScorecardView: PropTypes.bool,
};

export default EvidenceDownloadButton;
